export const faceBookBlacklistEvents = [
  'Photo Pre-Signed URL Retrieved',
  'Photo Uploaded',
]
